<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div           class="blade-tools">
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized ">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <h6 class="hubdesc">{{hubDescription}}</h6>
          <div class="hub-filters">
            <div class="fieldsetsGroup">
              <div [formGroup]="formGroup"
                   class="formdata">
                <div data-cy="fieldset-id-warehouse_filter"
                     *ngIf="!filtersets.warehouse_filter.hidden && !filtersets.warehouse_filter.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': filtersets.warehouse_filter.collapsible }">
                    <div *ngIf="!filtersets.warehouse_filter.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="filtersets.warehouse_filter.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{filtersets.warehouse_filter.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="filtersets.warehouse_filter.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !filtersets.warehouse_filter.expanded, 'icon-ic_fluent_chevron_up_20_filled': filtersets.warehouse_filter.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="filtersets.warehouse_filter.expanded"
                         class="fieldsetsGroup">
                            <div data-cy="field-id-warehouse" *ngIf="!filters.warehouse.hidden && !filters.warehouse.removed" 
                                  class="field-container standard {{filters.warehouse.invalid ? 'invalid' : ''}} {{filters.warehouse.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.warehouse.styles.style"
                                  [ngClass]="filters.warehouse.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.warehouse.label + (filters.warehouse.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.warehouse.label}}<span *ngIf="filters.warehouse.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Manufacturing-warehouses_dd_single 
                                  data-cy="selector"
                                  [type]="filters.warehouse.control.type"
                                  formControlName="warehouse"
                                  (displayTextChange)="filters.warehouse.control.displayText=$event"
                                  [placeholder]="filters.warehouse.control.placeholder"
                                  [styles]="filters.warehouse.control.styles"
                                  [tooltip]="filters.warehouse.control.tooltip"
                              >
                              </Manufacturing-warehouses_dd_single>
                              <ng-container *ngIf="filters.warehouse.invalid">
                                <ng-container *ngFor="let error of filters.warehouse.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>            </div>
              
                          <div class="fieldset-details" *ngIf="!filtersets.warehouse_filter.expanded">
              
              
                          </div>
                        </div>
                      </div>
                    </div>
            </div>
          </div>
        </div>


        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="tabs.workshifts.hasTabToShow" class="tab" data-cy="tab-workshifts">
              <h2 [className]="tabs.workshifts.active? 'active': ''" (click)="tabs.workshifts.activate()">{{tabs.workshifts.title}}</h2>
            </div>
            <div *ngIf="tabs.equipment.hasTabToShow" class="tab" data-cy="tab-equipment">
              <h2 [className]="tabs.equipment.active? 'active': ''" (click)="tabs.equipment.activate()">{{tabs.equipment.title}}</h2>
            </div>
          </div>
        
              <FootprintManager-manufacturing_workshifts_grid *ngIf="tabs.workshifts.active"
              #$tabs_workshifts
              [warehouse]="$tabs_workshifts_manufacturing_workshifts_grid_inParams_warehouse"
              ($refreshEvent)="refresh(false, false, '$tabs_workshifts')">
              </FootprintManager-manufacturing_workshifts_grid>
              <FootprintManager-manufacturing_equipment_grid *ngIf="tabs.equipment.active"
              #$tabs_equipment
              [warehouse]="$tabs_equipment_manufacturing_equipment_grid_inParams_warehouse"
              ($refreshEvent)="refresh(false, false, '$tabs_equipment')">
              </FootprintManager-manufacturing_equipment_grid>
        </div>

      </ng-container>
    </div>
  </div>
</div>